import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const updateContactBoardAndColumn = async <
  T extends Record<string, unknown>,
>({
  boardId,
  columnId,
  contactId,
  destinationBoardId,
  index,
  sourceBoardId,
  headers,
  domain,
  query,
}: FetchRequestArgs & {
  boardId: string;
  columnId: string;
  contactId: string;
  destinationBoardId: string;
  sourceBoardId: string;
  index: number;
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    data: {
      columnID: columnId,
      contactID: contactId,
      destinationBoardID: destinationBoardId,
      index,
      sourceBoardID: sourceBoardId,
    },
    domain,
    endpoint: `/boards/${boardId}/contact/transfer`,
    headers,
    method: HTTPMethod.PUT,
    query,
  });
